"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  sl: {
    "fields": {
      "messages": {
        "hideNotesConfirm": "Ali ste prepričani, da želite izbrisati opombo? Izgubili boste njeno vsebino."
      },
      "actions": {
        "addNote": "Dodat opombo",
        "removeNote": "Izbriši opombo",
        "unlock": "Odkleni"
      }
    }
  }
};
var _default = messages;
exports.default = _default;